export default __webpack_public_path__ + "static/media/apple.b13f5ecc.svg";